import { Component, inject, Input, OnInit } from '@angular/core';
import { DynamicFormService } from '@ntap/common';
import { ItemViewProviderDirective } from '@ntap/core';
import { distinct, map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-objekti-pojavnog-oblika',
  templateUrl: './objekti-pojavnog-oblika.component.html',
  styleUrls: ['./objekti-pojavnog-oblika.component.scss']
})
export class ObjektiPojavnogOblikaComponent implements OnInit {
  public tipPojavnogOblika$: Observable<string>;

  protected formService = inject(DynamicFormService);
  protected parentItemView = inject(ItemViewProviderDirective);

  @Input()
  activeTab: number;

  parentViewName$: Observable<string>;

  ngOnInit(): void {
    this.parentViewName$ = this.parentItemView.view$.pipe(
      map((v) =>
        v.name.indexOf('_readonly') > 0 ? 'datoteke_readonly' : 'datoteke'
      )
    );
    this.tipPojavnogOblika$ = this.formService.formGroup$.pipe(
      switchMap((g) =>
        g.statusChanges.pipe(
          switchMap(() =>
            g.valueChanges.pipe(
              map(
                (groupVal) => groupVal['en~pojavni_oblik~tip_pojavnog_oblika']
              ),
              distinct()
            )
          )
        )
      )
    );
  }
}
